import { Box, BoxProps } from "@chakra-ui/react"

export function CardContent(props: BoxProps) {
    return (
        <Box {...props} />
    )
}
